import { useTranslation } from "react-i18next";
import { Chargebacks } from "@/partner/features/chargebacks";
import { Meta } from "@/shared/components";

export function ChargebacksPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("chargebacks.pageTitle")} pageType="Partner" />
      <Chargebacks />
    </>
  );
}
